import { Routes, Route, Navigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

// Components
// import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { MainLayout } from './components/MainLayout/MainLayout';
import { DocumentTitle } from './components/DocumentTitle/DocumentTitle';

// Protected Pages
import AppointmentPage from './pages/AppointmentPage/AppointmentPage';
import { AuthProvider } from './contexts/AuthContext';
import { EmbeddedProvider } from './contexts/EmbeddedContext';
import EventsPage from './pages/EventsPage/EventsPage';
import { useIframeResize } from './hooks/useIframeResize';

function AppContent() {
  const [searchParams] = useSearchParams();
  const isPrivateAppointment = searchParams.get('privateAppointments') === 'true';

  // Enable automatic height communication with parent window
  useIframeResize();

  return (
    <>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={
          isPrivateAppointment ? (
            <Navigate to={`/appointment?${searchParams.toString()}`} replace />
          ) : (
            <MainLayout>
              <EventsPage />
            </MainLayout>
          )
        } />
        <Route path="/events" element={
          <MainLayout>
            <EventsPage />
          </MainLayout>
        } />
        <Route
          path="/home"
          element={
            // <ProtectedRoute>
            <MainLayout>
              <EventsPage />
            </MainLayout>
            // </ProtectedRoute>
          }
        />
        <Route
          path="/appointment"
          element={
            //<ProtectedRoute>
            <MainLayout>
              <AppointmentPage />
            </MainLayout>
            //</ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <EmbeddedProvider>
        <AppContent />
      </EmbeddedProvider>
    </AuthProvider>
  );
}

export default App;
